import { OperatorFunction, filter, map } from 'rxjs';
import { HostMessage, HostMessageType } from '../interfaces/host-message-types';

/**
 * Custom RxJS operator that filters incoming host messages by type
 * and casts them to the expected generic payload type.
 */
export function ofMessageType<T>(
  type: HostMessageType
): OperatorFunction<HostMessage, HostMessage<T>> {
  return source$ =>
    source$.pipe(
      filter(msg => msg.type === type),
      map(msg => msg as HostMessage<T>)
    );
}
